module.exports = __webpack_public_path__ + "assets/img/team.c42c9fb5.svg";